import * as React from 'react';

import { cn } from '@/lib/utils';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
	({ className, ...props }, ref) => {
		return (
			<textarea
				data-slot="textarea"
				className={cn(
					'border-input placeholder:text-placeholder placeholder:font-light placeholder-shown:font-normal focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive bg-[#fafafa] dark:bg-slate-900 flex field-sizing-content min-h-16 w-full rounded-md border px-3 py-2 text-base font-semibold shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
					className
				)}
				ref={ref}
				{...props}
			/>
		);
	}
);

Textarea.displayName = 'Textarea';

export { Textarea };
